import { createStore, applyMiddleware, compose } from 'redux';
import Reactotron from 'config/reactotron'
import thunk from 'redux-thunk';
import rootReducer from './reducers';

const Store = createStore(
    rootReducer,
    compose(
        applyMiddleware(thunk),
        Reactotron.createEnhancer())
);

export default Store;